{
  "$id": "wealthlane://forms/job-scheduler-recurrence",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../job-scheduler.domain.json",
  "dataSource": {
    "submit": {
      "actionId": "SAVE_JOB_SCHEDULER_RECURRENCE",
      "successMessage": "Custom recurrence applied."
    }
  },
  "properties": {
    "recurrenceStartDateAnchor": {
      "$ref": "module://job-scheduler#properties/recurrenceStartDateAnchor"
    },
    "repeatEvery": {
      "$ref": "module://job-scheduler#properties/repeatEvery",
      "required": true
    },
    "repeatUnit": {
      "$ref": "module://job-scheduler#properties/repeatUnit",
      "required": true,
      "actionId": "FETCH_JOB_SCHEDULER_RECURRENCE_UNITS"
    },
    "repeatOnDays": {
      "$ref": "module://job-scheduler#properties/repeatOnDays",
      "hiddenWhen": { "field": "repeatUnit", "notEquals": "week" },
      "requiredWhen": { "field": "repeatUnit", "equals": "week" }
    },
    "endType": {
      "$ref": "module://job-scheduler#properties/endType",
      "required": true
    },
    "endOn": {
      "$ref": "module://job-scheduler#properties/endOn",
      "disabledWhen": { "field": "endType", "notEquals": "on" },
      "requiredWhen": { "field": "endType", "equals": "on" },
      "reactions": [
        {
          "watch": ["recurrenceStartDateAnchor"],
          "set": "minDate",
          "compute": { "operator": "field", "name": "recurrenceStartDateAnchor" }
        }
      ]
    },
    "occurrencesLimit": {
      "$ref": "module://job-scheduler#properties/occurrencesLimit",
      "disabledWhen": { "field": "endType", "notEquals": "after" },
      "requiredWhen": { "field": "endType", "equals": "after" }
    }
  },
  "modes": {
    "create": {
      "lifecycle": {
        "submitBehavior": "close"
      }
    }
  }
}
